import { useEffect } from "react";

const VerifyPaymentModal = ({ open, onClose, onSubmit }) => {
  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, [open]);

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    const data = {
      upiId: form.upiId.value.trim(),
      holderName: form.holderName.value.trim(),
      txnId: form.txnId.value.trim(),
      utr: form.utr.value.trim(),
    };

    onSubmit(data);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">

      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/40"
      />

      {/* Modal */}
      <div className="relative w-full max-w-md bg-white rounded-xl shadow-lg p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          Verify Payment
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">

          {/* UPI ID */}
          <div className="flex items-center gap-3">
            <label className="w-44 text-sm text-gray-700">
              Your UPI ID:
            </label>
            <input
              name="upiId"
              required
              placeholder="yourname@bank"
              className="flex-1 border rounded-md px-3 py-2 text-sm"
            />
          </div>

          {/* Holder Name */}
          <div className="flex items-center gap-3">
            <label className="w-44 text-sm text-gray-700">
              Your UPI Holder name:
            </label>
            <input
              name="holderName"
              required
              className="flex-1 border rounded-md px-3 py-2 text-sm"
            />
          </div>

          {/* Transaction ID */}
          <div className="flex items-center gap-3">
            <label className="w-44 text-sm text-gray-700">
              Your Transaction ID:
            </label>
            <input
              name="txnId"
              className="flex-1 border rounded-md px-3 py-2 text-sm"
            />
          </div>

          {/* UTR */}
          <div className="flex items-center gap-3">
            <label className="w-44 text-sm text-gray-700">
              UTR / Reference No:
            </label>
            <input
              name="utr"
              required
              pattern="\d{11,12}"
              placeholder="11 digits / 12 characters"
              className="flex-1 border rounded-md px-3 py-2 text-sm"
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-md text-sm"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-green-600 text-white rounded-md text-sm"
            >
              Verify Payment
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default VerifyPaymentModal;